export function lerp(start: number, end: number, t: number) {
  return start * (1 - t) + end * t;
}

export function calculatePercentage(
  value: number,
  minValue: number,
  maxValue: number
) {
  if (value < minValue) {
    return 0;
  } else if (value > maxValue) {
    return 1;
  } else {
    return (value - minValue) / (maxValue - minValue);
  }
}
